module.exports = __webpack_public_path__ + "img/consultPhone4.a5960d84.png";